import { View, Text, StyleSheet } from '@react-pdf/renderer';
import { PDF_FONT_SIZE } from './constants';

export default function KeyValuePDF({ label, value }) {
  const styles = StyleSheet.create({
    infoDetails: {
      display: 'flex',
      flexDirection: 'column',
      gap: 3,
      paddingTop: 5,
      paddingBottom: 5,
      margin: 5,
    },
    infoTitle: {
      fontSize: PDF_FONT_SIZE.TITLE,
      fontWeight: 'extrabold',
    },
    infoValue: {
      fontSize: PDF_FONT_SIZE.VALUE,
    },
    infoContainer: {
      backgroundColor: '#f0f0f0',
      borderTopLeftRadius: 6,
      borderTopRightRadius: 6,
    },
  });
  return (
      <View style={styles.infoDetails}>
        <Text style={styles.infoTitle}>{label}</Text>
        <Text style={styles.infoValue}>{value}</Text>
      </View>
  );
}
